import { gql } from '@apollo/client'

export { adminQuoteModelRevisionQuery } from './adminQuoteModelRevisionQuery'

export const getProjectIdQuery = gql`
    query getProjectIdQuery($id: UUID!, $showDeleted: Boolean) {
        quoteModelRevision(id: $id, showDeleted: $showDeleted) {
            id
            quoteModel {
                id
                quote {
                    id
                    project {
                        id
                    }
                }
            }
        }
    }
`

export const qmrAttachemntQuery = gql`
    query adminQuoteModelRevisionAttachment($id: UUID!, $showDeleted: Boolean) {
        quoteModelRevision(id: $id, showDeleted: $showDeleted) {
            id
            attachmentLink {
                id
                quoteAttachmentRevision {
                    id
                    attachment {
                        ... on Attachment {
                            id
                            downloadUrl
                        }
                    }
                }
            }
        }
    }
`

export const qmrQuantityRangeQuery = gql`
    query quantityRangesQuery {
        quantityRanges {
            id
            quantityLowerRange
            quantityUpperRange
        }
    }
`

export const generateModelConfigurationDfmInspectionQuery = gql`
    query generateModelConfigurationDfmInspection(
        $quoteModelRevisionId: UUID!
        $modelConfigOverrides: ConfigInput!
    ) {
        generateModelConfigurationDfmInspection(
            quoteModelRevisionId: $quoteModelRevisionId
            modelConfigOverrides: $modelConfigOverrides
        ) {
            id
            quantityLowerRange
            quantityUpperRange
            inspectionData
            isPublished
        }
    }
`

export const similarQuoteModelRevisionsQuery = gql`
    query similarQuoteModelRevisionsQuery($quoteModelRevisionId: UUID!) {
        quoteModelRevision(id: $quoteModelRevisionId) {
            id
            similarQuoteModelRevisions {
                id
                version
                fileName
                state
                partRevision {
                    id
                    thumbnailUri
                    isMirror
                }
                processesDetails {
                    totalPrice {
                        ... on ExactPrice {
                            priceInCents
                            unitPriceInCents
                        }
                        ... on EstimatedPrice {
                            lowPriceInCents
                            lowUnitPriceInCents
                            highPriceInCents
                            highUnitPriceInCents
                        }
                    }
                }
            }
        }
    }
`

export const lastUpdatedQuery = gql`
    query adminQmrLastUpdated($id: UUID!) {
        quoteModelRevision(id: $id) {
            id
            partRevision {
                id
                updatedAt
            }
        }
    }
`

export const destroyDfmFeedbackMutation = gql`
    mutation destroyDfmFeedback($dfmFeedbackId: UUID!) {
        destroyDfmFeedback(dfmFeedbackId: $dfmFeedbackId) {
            id
        }
    }
`

export const updateDfmFeedbackInfoMutation = gql`
    mutation updateDfmFeedbackInfo(
        $dfmFeedbackId: UUID!
        $severity: String
        $message: String
        $isPublished: Boolean
        $title: String
        $link: String
        $code: String
    ) {
        updateDfmFeedbackInfo(
            dfmFeedbackId: $dfmFeedbackId
            severity: $severity
            message: $message
            isPublished: $isPublished
            title: $title
            link: $link
            code: $code
        ) {
            id
        }
    }
`

export const createModelViewerSnapshotMutation = gql`
    mutation createModelViewerSnapshot(
        $quoteModelRevisionId: UUID!
        $position: JSON!
        $target: JSON!
        $feature: String!
        $type: String!
        $snapshot: ModelViewerConfigInput!
    ) {
        createModelViewerSnapshot(
            attrs: {
                quoteModelRevisionId: $quoteModelRevisionId
                position: $position
                target: $target
                feature: $feature
                type: $type
                snapshot: $snapshot
            }
        ) {
            id
        }
    }
`

export const updateModelViewerSnapshotMutation = gql`
    mutation updateModelViewerSnapshot(
        $dfmSnapshotId: UUID!
        $attrs: ModelViewerSnapshotInput!
    ) {
        updateModelViewerSnapshot(
            dfmSnapshotId: $dfmSnapshotId
            attrs: $attrs
        ) {
            id
        }
    }
`

export const createModelConfigurationDfmFeedbackMutation = gql`
    mutation createModelConfigurationDfmFeedback(
        $modelConfigurationId: UUID!
        $modelViewerSnapshotId: UUID!
        $severity: String!
        $message: String!
        $title: String
        $link: String
        $code: String
    ) {
        createModelConfigurationDfmFeedback(
            attrs: {
                modelConfigurationId: $modelConfigurationId
                modelViewerSnapshotId: $modelViewerSnapshotId
                severity: $severity
                message: $message
                title: $title
                link: $link
                code: $code
            }
        ) {
            id
        }
    }
`

export const updateModelConfigurationDfmInspectionMutation = gql`
    mutation updateModelConfigurationDfmInspection(
        $modelConfigurationDfmInspectionId: UUID!
        $inspectionData: InspectionDataInput!
        $lastModifiedAt: Date
        $override: Boolean
        $isQuantityRangeAvailable: Boolean
    ) {
        updateModelConfigurationDfmInspection(
            modelConfigurationDfmInspectionId: $modelConfigurationDfmInspectionId
            inspectionData: $inspectionData
            lastModifiedAt: $lastModifiedAt
            override: $override
            isQuantityRangeAvailable: $isQuantityRangeAvailable
        ) {
            id
        }
    }
`

export const addModelConfigurationDfmInspectionMutation = gql`
    mutation addModelConfigurationDfmInspection(
        $modelConfigurationId: UUID!
        $inspectionData: InspectionDataInput!
        $quantityRangeData: QuantityRangeInput!
    ) {
        addModelConfigurationDfmInspection(
            modelConfigurationId: $modelConfigurationId
            inspectionData: $inspectionData
            quantityRangeData: $quantityRangeData
        ) {
            id
            quantityLowerRange
            quantityUpperRange
            isQuantityRangeAvailable
            isPublished
            updatedBy {
                id
            }
            inspectionData
        }
    }
`

export const publishQuoteModelRevisionMutation = gql`
    mutation publishQuoteModelRevision(
        $quoteModelRevisionId: UUID!
        $quantityLowerRange: Int
        $quantityUpperRange: Int
    ) {
        publishQuoteModelRevision(
            quoteModelRevisionId: $quoteModelRevisionId
            quantityLowerRange: $quantityLowerRange
            quantityUpperRange: $quantityUpperRange
        ) {
            id
        }
    }
`

export const rawPdfOcrJsonQuery = gql`
    query getPdfOcrOutput($quoteModelRevisionId: UUID!) {
        getRawPdfOcrJson(quoteModelRevisionId: $quoteModelRevisionId) {
            finishingNotes
            foundThreadNames
            measurementUnits
            minOneSidedTolerance
            minTwoSidedTolerance
            autoQuotableBlockers
            numTightTolerances
            numVeryTightTolerances
            rawAnalysis
            requiresCertificateOfConformance
            requiresMaterialCertificate
            toleranceBlocks {
                textRaw
                symbol
            }
        }
    }
`

export const quotabilityBlockerQuery = gql`
    query quotabilityBlockersAdminQuotingPage($quoteModelRevisionId: UUID!) {
        quotabilityBlockers(quoteModelRevisionId: $quoteModelRevisionId)
    }
`

export const markQuoteModelRevisionFlagsAdminQuotingPageMutation = gql`
    mutation markQuoteModelRevisionFlagsAdminQuotingPage(
        $quoteModelRevisionId: UUID!
        $flags: [QmrFlag]
    ) {
        markQuoteModelRevisionFlags(
            quoteModelRevisionId: $quoteModelRevisionId
            flags: $flags
        ) {
            id
            flags
        }
    }
`
export const adminQuotingPageLockQMRToSingleQuoteMutation = gql`
    mutation adminQuotingPageLockQMRToSingleQuote(
        $quoteModelRevisionId: UUID!
        $flag: Boolean!
    ) {
        lockQMRToSingleQuote(
            quoteModelRevisionId: $quoteModelRevisionId
            flag: $flag
        ) {
            id
            isExclusiveToSingleQuote
        }
    }
`

export const adminReprocessPartMutation = gql`
    mutation adminReprocessPartMutation(
        $partId: Int!
        $reprocessParameters: ReprocessParametersInput
    ) {
        finalizeUploadAndProcessPart(
            partId: $partId
            reprocessParameters: $reprocessParameters
        ) {
            partId
            status
            reason
        }
    }
`
